import React from "react";
import { Switch, Route } from "react-router-dom";
import Page from "./Page";
import {
  LandingPage,
  ContactUs,
  Search,
  Reports,
  ApplyForEPAID,
  TonnageReport,
  CompanyReport,
  TransporterReport,
  FindManifestsReport,
  ManifestCountTonnageReport,
  FacilityProfile,
  TransporterProfile,
  HazardousWasteHandlerSummaryReport,
  EntityAssociationWithSpecificWasteReport,
  // TonnageByWasteCodeReport,
  // TonnageByRcraWasteCodeReport,
  // TonnageByDisposalCodeReport,
  ShipmentsByWasteCodeReport,
  TannerReportPublic,
  TannerReportRegulatory,
  EntitiesWhichInterfaceReport,
  CorrectionLetterManifestReport,
  ExportCupaDataToCsv,
  TqrDetailReport,
  TqrSubmissionsReport,
  DaysInTransitReport,
  TransportersWithHighTransitDaysReport,
  TransporterWasteDetailReport,
  TransporterCalcReport,
  HistoricalManifestsReport,
  LargeQuantityGeneratorsReport,
  DotDensityTestMapView,
  FacilitiesMap,
  ActiveFacilitiesMap,
  HwtsFeatureMap,
  NotFound,
  Profile,
  SearchManifests,
  ManifestSearch,
  Redirect,
  Searchv2,
  WasteCodeMatrixReport,
  ActiveVsInactiveMap,
  ArcGISExperienceEmbedTest,
  TempidApplication,
  Instructions,
  EmailVerification,
  QuarterFacilityExportReport,
  LqgClosureReport,
  ConfirmLetterReport
} from "../components/pages";
import { ProtectedRoute } from "./";

const Main = () => {
  return (
    <main>
      <Switch>
        <Route path="/contact-us" render={(props) => (
          <Page title="Contact Us">
            <ContactUs {...props} />
          </Page>)} />
        <Route path="/search" render={(props) => (
          <Page title="Handler Search">
            <Search {...props} />
          </Page>)} />
        {/* <Route path="/searchv2" component={Searchv2} /> */}
        <Route path="/search-manifests" render={(props) => (
          <Page title="Manifest Search">
            <SearchManifests {...props} />
          </Page>)} />
        <Route path="/reports/advanced-handler-search" render={(props) => (
          <Page title="Advanced Handler Search">
            <CompanyReport {...props} />
          </Page>)} />
        <Route path="/reports/transporter/:id" render={(props) => (
          <Page title="Transporter Profile">
            <TransporterProfile {...props} />
          </Page>)} />
        <Route path="/reports/transporter" render={(props) => (
          <Page title="Transporter Search">
            <TransporterReport {...props} />
          </Page>)} />
        <Route path="/reports/tonnage" render={(props) => (
          <Page title="Tonnage Report">
            <TonnageReport {...props} />
          </Page>)} />
        <Route path="/reports/manifest"
          render={(props) => (
            <Page title="Find Manifests Report">
              <FindManifestsReport {...props} />
            </Page>)} />
        <Route
          path="/reports/hazardous-waste-summary"
          render={(props) => (
            <Page title="Hazardous Waste Handler Summary Report">
              <HazardousWasteHandlerSummaryReport {...props} />
            </Page>
          )}
        />
        <Route path="/reports/tanner-report" render={(props) => (
          <Page title="Tanner Report">
            <TannerReportPublic {...props} />
          </Page>)} />
        <ProtectedRoute
          path="/reports/tanner-report-regulatory"
          title="Tanner Report (CDTFA)"
          component={TannerReportRegulatory}
        />
        <ProtectedRoute
          path="/reports/entities-which-interface-report"
          title="Entities Which Interface Report"
          component={EntitiesWhichInterfaceReport}
        />
        <ProtectedRoute
          path="/reports/quarter-facility-export-report"
          component={QuarterFacilityExportReport}
        />
        <ProtectedRoute
          path="/reports/confirm-letters"
          component={ConfirmLetterReport} 
        />
        {/* Agency Reports */}
        <ProtectedRoute
          path="/reports/manifest-tonnage"
          title="Manifest Counts and Tonnage Report"
          component={ManifestCountTonnageReport}
        />
        <ProtectedRoute
          path="/reports/waste-code-matrix"
          title="Waste Code Matrix Report"
          component={WasteCodeMatrixReport}
        />
        {/* <ProtectedRoute
          path="/reports/tonnage-by-waste"
          component={TonnageByWasteCodeReport}
        />
        <ProtectedRoute
          path="/reports/tonnage-by-rcra-waste"
          component={TonnageByRcraWasteCodeReport}
        />
        <ProtectedRoute
          path="/reports/tonnage-by-disposal"
          component={TonnageByDisposalCodeReport}
        /> */}
        <ProtectedRoute
          path="/reports/correction-letter-manifest-report"
          title="Manifests with Corrections Report"
          component={CorrectionLetterManifestReport}
        />
        <ProtectedRoute
          path="/reports/entities-by-waste"
          title="Entity Association with Specific Waste Report"
          component={EntityAssociationWithSpecificWasteReport}
        />
        <ProtectedRoute
          path="/reports/shipments-by-waste"
          title="Shipments By Waste Code Report"
          component={ShipmentsByWasteCodeReport}
        />
        <ProtectedRoute
          path="/reports/cupa-export-csv"
          title="CUPA Export to CSV Report"
          component={ExportCupaDataToCsv}
        />
        {/* <ProtectedRoute
          path="/reports/tanner-report-regulatory"
          component={TannerReportRegulatory}
        />

         <ProtectedRoute
          path="/reports/tqr-detail-export-csv"
          component={ExportTqrDetailDataToCsv}
        /> */}
        <ProtectedRoute
          path="/reports/tqr-detail-report"
          title="TQR Detail Report"
          component={TqrDetailReport}
        />
        <ProtectedRoute
          path="/reports/tqr-submissions-report"
          title="TQR Submissions Report"
          component={TqrSubmissionsReport}
        />
        <ProtectedRoute
          path="/reports/transporters-with-high-transit-days"
          title="Transporters with High Transit Days Report"
          component={TransportersWithHighTransitDaysReport}
        />
        <ProtectedRoute
          path="/reports/days-in-transit-report"
          title="Transporter Days In Transit Report"
          component={DaysInTransitReport}
        />
        <ProtectedRoute
          path="/reports/transporter-waste-detail-report"
          title="Transporter Waste Detail Report"
          component={TransporterWasteDetailReport}
        />
        <ProtectedRoute
          path="/reports/transporter-calc-report"
          title="Transporter Summary Report"
          component={TransporterCalcReport}
        />
        <ProtectedRoute
          path="/reports/historical-manifests-report"
          title="Historical Manifests Report"
          component={HistoricalManifestsReport}
        />
        <ProtectedRoute
          path="/reports/large-quantity-generators-report"
          title="Large Quantity Generators Report"
          component={LargeQuantityGeneratorsReport}
        />
        <ProtectedRoute 
          path="/reports/large-quantity-generator-closure-report"
          title="LQG Closure Report"
          component={LqgClosureReport}
        />
        <ProtectedRoute
          path="/reports/dot-density-test"
          title="Dot Density Test"
          component={DotDensityTestMapView}
        />
        <ProtectedRoute
          path="/reports/facilities-search-map-test"
          title="Facilities Search Map Test"
          component={FacilitiesMap}
        />
        <ProtectedRoute
          path="/reports/search-active-test"
          title="Active vs Inactive Map"
          component={ActiveVsInactiveMap}
        />
        <ProtectedRoute
          path="/reports/hwts-feature-map-test"
          title="HWTS Features Map Test"
          component={HwtsFeatureMap}
        />
        <ProtectedRoute
          path="/maps/hwts-active-inactive-map"
          title="Active vs Inactive Map"
          component={ActiveVsInactiveMap}
        />
        <ProtectedRoute
          path="/maps/arcgis-experience-builder-test-map"
          title="ArcGIS Experience Embed Test"
          component={ArcGISExperienceEmbedTest}
        />
        <Route path="/tempidapplication" render={(props) => (
          <Page title="Temporary ID Number Application">
            <TempidApplication {...props} />
          </Page>)} />
        <Route path="/tempidverify" render={(props) => (
          <Page title="Temporary ID Number Email Verification">
            <EmailVerification {...props} />
          </Page>)} />
        <Route path="/tempid" render={(props) => (
          <Page title="Temporary ID Number Application Instructions">
            <Instructions {...props} />
          </Page>)} />
        <Route path="/manifest/:manifest_id" render={(props) => (
          <Page title="Manifest">
            <ManifestSearch {...props} />
          </Page>)} />
        <Route exact path="/reports" render={(props) => (
          <Page title="Reports Menu">
            <Reports {...props} />
          </Page>)} />
        <Route path="/apply-for-epa-id" render={(props) => (
          <Page title="Apply For a Hazardous Waste ID Number">
            <ApplyForEPAID {...props} />
          </Page>)} />
        <Route path="/facility/:id" render={(props) => (
          <Page title="Handler Profile">
            <FacilityProfile {...props} />
          </Page>)} />
        <ProtectedRoute path="/profile" title="User Profile" component={Profile} />
        <Route path="/redirect" render={(props) => (
          <Page title="Redirect">
            <Redirect {...props} />
          </Page>)} />
        <Route exact path="/" render={(props) => (
          <Page title="Home">
            <LandingPage {...props} />
          </Page>)} />
        <Route path="*" render={(props) => (
          <Page title="Page Not Found">
            <NotFound {...props} />
          </Page>)} />
      </Switch>
    </main>
  );
};

export default Main;
